import { QUERY_PARAM } from '@commons/constants';
import { removeQueryParamsFromURL } from '@utils/url';
import { isServer } from '@commons/utils';

export default function getShopDetailsRoute() {
  if (isServer()) return '/';
  const { pathname, search } = window.location;
  const shopDetailsRoute = removeQueryParamsFromURL(
    pathname + search,
    QUERY_PARAM.PRODUCT_CONFIG,
    QUERY_PARAM.FEATURED_PRODUCT_CONFIG,
  );

  return shopDetailsRoute;
}
